export const toBoolean = (value) => value === 'true';
export const mapToSourceId = (value, safeHarbor) => {
  if (safeHarbor === 'safeHarbor' && (value === 4 || value === 5)) {
    return value;
  }
  return value + 1009;
};

export const getServiceEligibility = async (serviceEligibility) => {
  if (serviceEligibility === undefined) {
    return 'ONE_YEAR_HOURS';
  }
  if (serviceEligibility.value === 'oneMonth') {
    return 'ONE_MONTH';
  }
  if (
    serviceEligibility.value === 'threeMonths' ||
    serviceEligibility.value === 'THREE_MONTHS'
  ) {
    return 'THREE_MONTHS';
  }
  if (serviceEligibility.value === 'sixMonths') {
    return 'SIX_MONTHS';
  }
  if (
    serviceEligibility.value === 'twelveMonths' ||
    serviceEligibility.value === '12months' ||
    serviceEligibility.value === 'TWELVE_MONTHS'
  ) {
    return 'TWELVE_MONTHS';
  }
  if (
    serviceEligibility.value === 'oneYear' ||
    serviceEligibility.value === 'oneYearService'
  ) {
    return 'ONE_YEAR_HOURS';
  }
  return 'IMMEDIATE';
};

export const getEntry = async (entryDatesPlanParticipation) => {
  if (entryDatesPlanParticipation.value === 'dailyImmediate') {
    return 'DAILY';
  }
  if (entryDatesPlanParticipation.value === 'monthly') {
    return 'MONTHLY';
  }
  if (entryDatesPlanParticipation.value === 'quarterly') {
    return 'QUARTERLY';
  }
  if (
    entryDatesPlanParticipation.value === 'semiAnnually' ||
    entryDatesPlanParticipation.value === 'semiannually'
  ) {
    return 'SEMI_ANNUALLY';
  }
  return 'ANNUALLY';
};

export const getVestingScheduleID = async (vestingScheduleMatch) => {
  if (vestingScheduleMatch.valueFormatted === '4-year graded') {
    return 22;
  }
  if (vestingScheduleMatch.valueFormatted === '5-year graded') {
    return 3;
  }
  if (vestingScheduleMatch.valueFormatted === '6-year graded') {
    return 2;
  }
  if (vestingScheduleMatch.valueFormatted === '3-year cliff') {
    return 6;
  }
  if (vestingScheduleMatch.valueFormatted === '2-year cliff = 0%, 100%') {
    return 5;
  }
  return 1;
};

export const getVestingScheduleFormula = async (vestingScheduleMatch) => {
  if (vestingScheduleMatch.valueFormatted === '4-year graded') {
    return '25,50,75,100';
  }
  if (vestingScheduleMatch.valueFormatted === '5-year graded') {
    return '20,40,60,80,100';
  }
  if (vestingScheduleMatch.valueFormatted === '6-year graded') {
    return '0,20,40,60,80,100';
  }
  if (vestingScheduleMatch.valueFormatted === '3-year cliff') {
    return '0,0,0,100';
  }
  if (vestingScheduleMatch.valueFormatted === '2-year cliff = 0%, 100%') {
    return '0,0,100';
  }
  return '100';
};

export const getSourceId = async (
  whichSafeHarborQaca,
  whichSafeHarbor,
  autoEnrollmentPlan,
) => {
  if (
    autoEnrollmentPlan !== undefined &&
    autoEnrollmentPlan.valueFormatted === 'QACA'
  ) {
    if (whichSafeHarborQaca.value.value === '3PercNonelectiveSafeharbor') {
      return 1001;
    }
    if (whichSafeHarborQaca.value.value === 'basicMatch100to1-50toNext6') {
      return 22;
    }
    if (whichSafeHarborQaca.value.value === 'enhancedMatch100to3.5') {
      return 1003;
    }
    if (whichSafeHarborQaca.value.value === 'enhancedMatch100to4') {
      return 1004;
    }
    if (whichSafeHarborQaca.value.value === 'enhancedMatch100to5') {
      return 1005;
    }
    return 1006;
  }
  if (whichSafeHarbor === undefined) {
    return 7;
  }
  if (whichSafeHarbor.value.value === '3PercNonelectiveSafeharbor') {
    return 8;
  }
  if (whichSafeHarbor.value.value === 'basicMatch100to3-50toNext2') {
    return 4;
  }
  if (whichSafeHarbor.value.value === 'enhancedMatch100to4') {
    return 5;
  }
  if (whichSafeHarbor.value.value === 'enhancedMatch100to5') {
    return 6;
  }
  return 7;
};

export const shouldSetPlanSourceFrequency = (sourceId) =>
  [4, 5, 6, 7, 1003, 22, 1004, 1005, 1006].includes(sourceId);

export const setPlanSourceFrequencyValue = (sourceId) =>
  shouldSetPlanSourceFrequency(sourceId) && 'PAYROLL';

export const getSourceName = async (
  whichSafeHarborQaca,
  whichSafeHarbor,
  autoEnrollmentPlan,
) => {
  if (
    autoEnrollmentPlan !== undefined &&
    autoEnrollmentPlan.valueFormatted === 'QACA'
  ) {
    if (whichSafeHarborQaca.value.value === '3PercNonelectiveSafeharbor') {
      return 'Employer QACA 3% Non-Elective';
    }
    if (whichSafeHarborQaca.value.value === 'basicMatch100to1-50toNext6') {
      return 'Employer QACA 100% up to 1% - 50% up to 6%';
    }
    if (whichSafeHarborQaca.value.value === 'enhancedMatch100to3.5') {
      return 'Employer QACA 3.5% Enhanced Match';
    }
    if (whichSafeHarborQaca.value.value === 'enhancedMatch100to4') {
      return 'Employer QACA 4% Match';
    }
    if (whichSafeHarborQaca.value.value === 'enhancedMatch100to5') {
      return 'Employer QACA 5% Match';
    }
    return 'Employer QACA 6% Match';
  }
  if (whichSafeHarbor === undefined) {
    return '';
  }
  if (whichSafeHarbor.value.value === '3PercNonelectiveSafeharbor') {
    return '3% Non-elective Safe harbor';
  }
  if (whichSafeHarbor.value.value === 'basicMatch100to3-50toNext2') {
    return 'Employer Safe Basic Match';
  }
  if (whichSafeHarbor.value.value === 'enhancedMatch100to4') {
    return 'Enhanced Match: 100% up to 4%';
  }
  if (whichSafeHarbor.value.value === 'enhancedMatch100to5') {
    return 'Enhanced Match: 100% up to 5%';
  }
  return 'Enhanced Match: 100% up to 6%';
};

export const getTpaFirmName = (tpaFirmName, tpaFirmNameUnlisted) => {
  if (
    tpaFirmName === undefined ||
    tpaFirmName.value.value === 'myFirmIsntListed'
  ) {
    return tpaFirmNameUnlisted.value;
  }
  return tpaFirmName.value.value;
};

export const getRequiredAge = async (minRequiredAge) => {
  if (minRequiredAge.value === '21' || minRequiredAge.value === 'age21') {
    return 21;
  }
  if (minRequiredAge.value === '18' || minRequiredAge.value === 'age18') {
    return 18;
  }
  return 0;
};

export const getAgeRequirement = async (
  minAgeReq,
  minAgeReqDiscretionaryContribtion,
) => {
  let ageReq;
  if (minAgeReq.value === '18' || minAgeReq.value === 'age18') {
    ageReq =
      minAgeReqDiscretionaryContribtion.value === '21' ||
      minAgeReqDiscretionaryContribtion.value === 'age21'
        ? minAgeReqDiscretionaryContribtion
        : minAgeReq;
  } else if (minAgeReq.value === '21' || minAgeReq.value === 'age21') {
    ageReq = minAgeReq;
  } else {
    ageReq = minAgeReqDiscretionaryContribtion;
  }
  return ageReq;
};

export const getServiceRequirement = async (
  minServiceReq,
  minServiceReqDiscretionary,
) => {
  let serviceReq;
  if (minServiceReq.value === 'noServiceRequirement') {
    serviceReq = minServiceReqDiscretionary;
  } else if (minServiceReq.value === 'oneYearService') {
    serviceReq = minServiceReq;
  } else if (minServiceReq.value === '12months') {
    serviceReq =
      minServiceReqDiscretionary.value === 'oneYearService' ||
      minServiceReqDiscretionary.value === 'oneYear'
        ? minServiceReqDiscretionary
        : minServiceReq;
  } else if (minServiceReq.value === 'sixMonths') {
    serviceReq =
      minServiceReqDiscretionary.value === '12months' ||
      minServiceReqDiscretionary.value === 'twelveMonths' ||
      minServiceReqDiscretionary.value === 'oneYearService' ||
      minServiceReqDiscretionary.value === 'oneYear'
        ? minServiceReqDiscretionary
        : minServiceReq;
  } else if (minServiceReq.value === 'threeMonths') {
    serviceReq =
      minServiceReqDiscretionary.value === '12months' ||
      minServiceReqDiscretionary.value === 'twelveMonths' ||
      minServiceReqDiscretionary.value === 'oneYearService' ||
      minServiceReqDiscretionary.value === 'oneYear' ||
      minServiceReqDiscretionary.value === 'sixMonths'
        ? minServiceReqDiscretionary
        : minServiceReq;
  } else if (minServiceReqDiscretionary.value !== 'noServiceRequirement') {
    serviceReq = minServiceReqDiscretionary;
  } else {
    serviceReq = minServiceReq;
  }
  return serviceReq;
};

export const getEntryDateRequirement = (
  entryDatePlan,
  entryDateDiscretionary,
) => {
  let entryDate;
  if (entryDatePlan.value === 'dailyImmediate') {
    entryDate = entryDateDiscretionary;
  } else if (entryDatePlan.value === 'monthly') {
    entryDate =
      entryDateDiscretionary.value !== 'dailyImmediate'
        ? entryDateDiscretionary
        : entryDatePlan;
  } else if (entryDatePlan.value === 'quarterly') {
    entryDate =
      entryDateDiscretionary.value !== 'dailyImmediate' &&
      entryDateDiscretionary.value !== 'monthly'
        ? entryDateDiscretionary
        : entryDatePlan;
  } else {
    entryDate = entryDatePlan;
  }
  return entryDate;
};

export const getInvestmentLineup = (investmentLineup) => {
  switch (investmentLineup.value) {
    case 'fundLineup1':
      return 'principal_std';
    case 'fundLineup2':
      return 'blackrock';
    case 'fundLineupOneDigital':
      return 'onedigital';
    default:
      return 'american';
  }
};

export const getContributionInfoBundled = async (
  safeHarbor,
  stretchMatch,
  employerMatch,
) => {
  if (safeHarbor.value === 'safeHarbor') {
    if (stretchMatch.value === '4') {
      return 4;
    }
    return 5;
  }
  return employerMatch.value + 1009;
};

export const requireReview = (advisor, advisorCvStatus) => {
  if (advisor.questions.firmName === undefined) {
    return true;
  }
  if (advisor.questions.firmName.value === 'I don’t see my broker-dealer') {
    return true;
  }
  if (advisorCvStatus === 'PASS') {
    return false;
  }
  return true;
};

export const handlePlanNumber = (planNumber) => {
  if (planNumber !== undefined && planNumber.dirty) {
    let { value } = planNumber;
    if (value.toString().length > 3) {
      value = ('0', value).slice(-3);
    }
    while (value.toString().length < 3) {
      value = `0${value}`;
    }
    return value;
  }
  return '001';
};

export const setVestingSchedule = (planDesign, tpaParadigmPackager) => {
  // eslint-disable-next-line camelcase
  const { bQaca_vestingScheduleQaca } = planDesign.questions;
  const {
    autoEnrollmentPlan = { value: '', valueFormatted: '' },
    vestingScheduleMatch = { value: '', valueFormatted: '' },
    vestingScheduleProfit = { value: '', valueFormatted: '' },
  } = tpaParadigmPackager;
  let vestingSchedule;
  if (autoEnrollmentPlan !== undefined && autoEnrollmentPlan.value === 'qaca') {
    // eslint-disable-next-line camelcase
    vestingSchedule = bQaca_vestingScheduleQaca;
  }
  if (
    (autoEnrollmentPlan !== undefined && autoEnrollmentPlan.value === 'aca') ||
    autoEnrollmentPlan.value === 'eaca' ||
    autoEnrollmentPlan.value === ''
  ) {
    if (vestingScheduleMatch !== undefined) {
      vestingSchedule = vestingScheduleMatch;
    }
    if (
      vestingScheduleMatch === undefined &&
      vestingScheduleProfit !== undefined
    ) {
      vestingSchedule = vestingScheduleProfit;
    }
    if (
      vestingScheduleProfit !== undefined &&
      vestingScheduleMatch !== undefined
    ) {
      vestingSchedule = vestingScheduleMatch;
    }
  }
  return vestingSchedule;
};

export const paradigmPaymentMethod = (
  compensation,
  brokerType,
  insuranceAgentCompType,
  role,
  investmentLineup,
) => {
  if (role === 'psivet') {
    return 'psivet';
  }
  if (
    role === 'onedigital' ||
    investmentLineup.value === 'fundLineupOneDigital'
  ) {
    return 'onedigital';
  }
  if (compensation === 'option_2' && brokerType === 'insuranceAgent') {
    // ia-direct
    if (insuranceAgentCompType === 'direct') {
      return 'ia-direct';
    }
    // ia-indirect
    return 'ia-indirect';
  }
  // indirect
  if (compensation === 'option_2') {
    return 'indirect';
  }
  // direct
  return 'direct';
};

export const getAdvisorBrokerDealer = (
  brokerType,
  advisor,
  collectionSource,
  role,
) => {
  if (role === 'psivet' || role === 'onedigital')
    return advisor.questions.firmName.value.value;
  if (brokerType === 'insuranceAgent')
    return advisor.advisorCredentialVerification.insuranceAgent;
  return advisor.questions.firmName?.value.broker_dealer_name;
};

export const defaultPlanVestingId = (userRole, vestingSchedule) =>
  vestingSchedule.value === 'immediate' ? 1 : 2;

export const setParadigmAdvisors = (
  advisors,
  planDesign,
  advisorCvStatus,
  role,
) => {
  const { advisorCompensation, advisorFee, advisorPoints, investmentLineup } =
    planDesign.questions;

  const paradigmPlanAdvisors = {
    feeCollectionSource:
      advisorCompensation.value === 'option_1' ? 'DIRECT' : 'ASSETS',
    disbursedByUbiquity:
      getInvestmentLineup(investmentLineup) === 'onedigital' ||
      role === 'onedigital',
  };

  if (advisorCompensation.value === 'option_2') {
    if (advisorFee.value) {
      paradigmPlanAdvisors.fixedAmount = parseInt([advisorFee.value], 10);
    } else {
      paradigmPlanAdvisors.bpsAmount = parseInt(
        advisorPoints?.valueFormatted,
        10,
      );
    }
  }

  const { brokerType } = advisors[0].advisorCredentialVerification;
  let advisorType;
  if (brokerType === 'insuranceAgent') {
    advisorType = 'IA';
  } else if (brokerType === 'brokerDealer') {
    advisorType = 'RR';
  } else if (brokerType === 'iarRia') {
    advisorType = 'IAR';
  } else {
    advisorType = '';
  }

  paradigmPlanAdvisors.actors = advisors.map((advisor, index) => {
    const hasNpnValue = !!advisor.questions.advisorNpn.value;
    const hasAdvisorCrd = !!advisor.advisorCredentialVerification.crd.value;
    const showAdvisorCrd = hasAdvisorCrd && !hasNpnValue;
    return {
      advisorService: 'NONE',
      ...(hasNpnValue && { advisorNpn: advisor.questions.advisorNpn.value }),
      requireReview: requireReview(advisor, advisorCvStatus[index]),
      isPrimary: index === 0,
      commissionPct: advisor.questions.compensation.value,
      roles:
        advisor.questions.compensation.value === 0
          ? ['NONCOMMISSIONABLE']
          : ['COMMISSIONABLE'],
      advisorType,
      ...(showAdvisorCrd && {
        advisorCrd: advisor.advisorCredentialVerification.crd.value,
      }),
    };
  });

  return paradigmPlanAdvisors;
};

export const checkRegisterTpaResponseStatus = (status) => {
  switch (status) {
    case 200:
    case 201:
    case 204:
    case 400:
      return true;
    default:
      return false;
  }
};

export const sourcesGrandfatherDate = (
  questions,
  tpaParadigmPackager = null,
) => {
  const {
    hasGrandfatherDate,
    grandfatherDateHasCustomDate,
    grandfatherDate,
    planEffectiveDate,
    hasTpa,
  } = questions;
  let planDate;

  if (hasTpa.value) {
    planDate =
      tpaParadigmPackager.planEffectiveDate === null ||
      tpaParadigmPackager.planEffectiveDate === undefined
        ? planEffectiveDate.value
        : tpaParadigmPackager.planEffectiveDate.value;
  } else {
    planDate = planEffectiveDate.value;
  }

  if (hasGrandfatherDate.value === 'no') return null;
  if (grandfatherDateHasCustomDate.value === 'no') return planDate;
  return grandfatherDate.value;
};
